export default "assets/images/logos_paypal-0d97600e.png";